import { useState, useEffect } from "react";
import {
  EliteIcon,
  MasterIcon,
  IntermediateIcon,
  NoviceIcon,
  ProficientIcon,
} from "../SvgIconsData";

// import novice from "../../../assets/images/timelines/novoice.svg";
// import intermediate from "../../../assets/images/timelines/intermediate.svg";
// import proficient from "../../../assets/images/timelines/proficient.svg";
// import master from "../../../assets/images/timelines/master.svg";
// import elite from "../../../assets/images/timelines/elite.svg";

export const medalXL = {
  Novice: <NoviceIcon width={"56.175"} height={"40.198"} />,
  Intermediate: <IntermediateIcon width={"66.175"} height={"50.198"} />,
  Proficient: <ProficientIcon width={"75"} height={"40.198"} />,
  Master: <MasterIcon width={"55.175"} height={"34.198"} />,
  Elite: <EliteIcon width={"56.175"} height={"40.198"} />,
};
